import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=357aa876&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=js&"
export * from "./tips.vue?vue&type=script&lang=js&"
import style0 from "./tips.vue?vue&type=style&index=0&id=357aa876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357aa876",
  null
  
)

export default component.exports